export default __webpack_public_path__ + "static/media/Daimler.52c0fd69.jpg";